/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';

import { InvalidSearchImg } from '../../../images/images';
import { Modal, ModalHeader } from '../../../UiKit';
import { EmptyState } from '../../commons';
import { getFullDate } from '../../commons/CommonMethods';
import { useQueryCall } from '../../../api/react-client';
import { toLower } from 'lodash-es';
import { useSelector } from 'react-redux';

function InstallationDetails({ orderId }) {
  const [showModal, setShowModal] = useState(false);
  const isNewUI = useSelector((state) => state?.ordersState?.isNewUI);

  const handleClose = () => setShowModal(false);

  return (
    <>
      {showModal ? (
        <InstallationDetailsModal orderId={orderId} handleClose={handleClose} />
      ) : null}
      <p
        className={
          isNewUI
            ? 'tw-text-300 tw-font-medium tw-text-base-green tw-cursor-pointer tw-leading-none'
            : 'colorGreen tw-mr-4'
        }
        onClick={() => setShowModal(true)}
      >
        Installation Details
      </p>
    </>
  );
}

export { InstallationDetails };

function InstallationDetailsModal({ orderId, handleClose }) {
  return (
    <Modal
      isVisible
      isMaxContent
      type={window.dashboard.mode === 'smartplug' ? 'huge' : 'large'}
      padding='0'
      paddingTop='1rem'
      maxHeight='60vh'
      showCloseIcon={false}
      showScrollBar={true}
      titleComponent={
        <div className='tw-w-full tw-m-8 tw-mb-0'>
          <ModalHeader
            title='Installation Details'
            textColor={'#000'}
            handleClose={handleClose}
          />
        </div>
      }
      containerStyles={{ margin: '16px 0 20px 0', padding: '0 20px' }}
      titleStyle={{
        fontSize: '17px',
        fontWeight: '900',
        marginLeft: '-0.4rem',
      }}
      handleClose={handleClose}
    >
      <InstallationDetailsList orderId={orderId} />
    </Modal>
  );
}
function InstallationDetailsList({ orderId }) {
  const getInstallationDetailsEndPoint = `installation/get_status?order_id=${orderId}`;
  const {
    data: installationDetails,
    isLoading,
    error,
    isError,
  } = useQueryCall({}, getInstallationDetailsEndPoint, [
    orderId,
    'installation_get_status',
  ]);

  if (isLoading) return <Shimmer height='20rem' width={'100%'} />;

  if (isError) {
    <div className='tw-w-full'>
      <EmptyState
        img={InvalidSearchImg}
        heading={error?.message || 'Something went wrong!'}
        isPop={true}
      />
      ;
    </div>;
  }

  if (!installationDetails || !installationDetails.length) {
    return (
      <div className='tw-w-full'>
        <EmptyState
          img={InvalidSearchImg}
          heading={'No Installation details on this order.'}
          isPop
        />
      </div>
    );
  }

  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-3'>
      <div className='tw-w-full tw-flex tw-justify-between tw-items-start [&>div]:tw-text-400 tw-gap-5 tw-p-5 tw-rounded-xl [&>div]:tw-h-full  [&>div]:tw-flex [&>div]:tw-items-start [&>div]:tw-justify-start tw-font-[500]'>
        <div className='tw-w-[20%]'>Status</div>
        <div className='tw-w-[20%]'>ETA</div>
        <div className='tw-w-[30%]'>Technician Details</div>
        <div className='tw-w-[30%]'>TimeStamp</div>
      </div>
      {installationDetails.map((details) => {
        const classesForSubHeadings =
          'tw-text-300 tw-font-medium tw-text-grey-600 tw-mr-2';
        const classesForSubHeadingValues =
          'tw-text-200 tw-font-medium tw-flex tw-text-grey-900';

        return (
          <div
            key={details?.product_id}
            className='tw-w-full tw-flex tw-gap-5  tw-border-[1px] tw-border-solid  hover:tw-border-[#E0E4EB] tw-border-indigo-050 tw-rounded-xl tw-bg-indigo-050 tw-justify-between tw-items-start  [&>div]:tw-flex tw-p-5 [&>div]:tw-break-words '
          >
            <div
              className={`${classesForSubHeadingValues} tw-w-[20%] tw-flex-col`}
            >
              <div className={classesForSubHeadingValues}>
                {details.status || 'NA'}{' '}
              </div>
              {details.reason ? (
                <div className={classesForSubHeadingValues}>
                  <span className={classesForSubHeadings}>Reason:</span>{' '}
                  {toLower(details.reason) || 'NA'}
                </div>
              ) : null}
              {details.product_name ? (
                <div className={`${classesForSubHeadingValues} tw-flex-col`}>
                  <span className={classesForSubHeadings}>Product:</span>{' '}
                  {toLower(details.product_name) || 'NA'}
                </div>
              ) : null}
            </div>
            <div className={`${classesForSubHeadingValues} tw-w-[20%]`}>
              {getFullDate(
                details.technician_details.expected_arrival * 1000,
              ) || 'NA'}
            </div>
            <div
              className={`${classesForSubHeadingValues} tw-flex-col tw-w-[30%]`}
              data-dd-privacy='mask'
            >
              <div className={classesForSubHeadingValues}>
                <span className={classesForSubHeadings}>Name:</span>{' '}
                {details.technician_details.name || 'NA'}
              </div>
              <div className={classesForSubHeadingValues}>
                <span className={classesForSubHeadings}>Phone:</span>{' '}
                {details.technician_details.phone_number || 'NA'}
              </div>
              <div className={classesForSubHeadingValues}>
                <span className={classesForSubHeadings}>Ext Case ID:</span>
                {details.external_case_id || 'NA'}
              </div>
            </div>
            <div
              className={`${classesForSubHeadingValues} tw-flex-col tw-w-[30%]`}
            >
              <div className={classesForSubHeadingValues}>
                <span className={classesForSubHeadings}>Created At:</span>{' '}
                {details.created_at
                  ? getFullDate(details.created_at * 1000)
                  : 'NA'}
              </div>
              <div className={classesForSubHeadingValues}>
                <span className={classesForSubHeadings}>Updated At:</span>{' '}
                {details.updated_at
                  ? getFullDate(details.updated_at * 1000)
                  : 'NA'}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
